import React from 'react';
import {
	Typography,
	Slider,
	TextField,
	Grid,
	Switch,
	FormGroup,
	FormControlLabel,
	FormControl,
	FormLabel,
	FormHelperText,
	RadioGroup,
	Radio,
	InputAdornment,
	IconButton,
	Tooltip
} from '@material-ui/core/';
import CreateCampaignStyles from '../../Styles/CreateCampaignStyles';
import { withStyles } from '@material-ui/core/styles';
import { Help } from '@material-ui/icons';
import { MuiPickersUtilsProvider, InlineDatePicker } from 'material-ui-pickers';
import moment from 'moment';
import MomentUtils from '@date-io/moment';
import './styles.css';

const AUTOPILOT_HELPTEXT = 'Vimma will optimise your budget usage by modifying the compensation paid to advocates based on their expected performance.Turning the budget optimisation off will pay everyone a flat fee, and might result into missing some of the greatest advocates!';
const COMPANY_NAME_HELPTEXT = 'This will be visible to the brand advocates participating to your campaign.';
const START_DATE_HELPTEXT = 'Ads will go live earliest on this date. Please set a date at least 10 days from today.';
const END_DATE_HELPTEXT = 'No more ads will be posted after this date.';

const marks = [
	{
		value: 2,
		label: '£200',
	},
	{
		value: 20,
		label: '£2000',
	},
	{
		value: 50,
		label: '£5000',
	},
	{
		value: 80,
		label: '£8000',
	},
	{
		value: 100,
		label: '£10000',
	},
]


function valueLabelFormat(value) {
	return value === 0 ? '£200' : value / 10 < 1 ? `£${value * 100}` : `£${value / 10}k`;
}


export const BasicScreen = ({ updateValue, values, errors, onChange, classes }) => {
	return (
		<div>
			<div className="campaign-step-header">
				<Typography variant="h5">
					Basics
            </Typography>
			</div>
			<Grid container >
				<Grid item xs={12} style={{ paddingBottom: '16px' }}>
					<FormLabel className={classes.typography}>Let's give this campaign a name!</FormLabel>
					<TextField
						id="campaignName"
						label="Campaign name"
						value={values.campaignName}
						onChange={onChange}
						fullWidth
						autoFocus
						margin="normal"
						variant="outlined"
						required={true}
						error={!!errors.campaignName}
						helperText={errors.campaignName ? errors.campaignName : COMPANY_NAME_HELPTEXT}
					/>
				</Grid>
				<Grid item xs={12} style={{ paddingBottom: '16px' }}>
					<FormLabel className={classes.typography}>Campaign budget</FormLabel>
					<div style={{ padding: '0 12px 0 12px' }} >
						<Slider
							id="budget"
							valueLabelFormat={valueLabelFormat}
							defaultValue={30}
							onChange={(event, value) => updateValue(value * 100, 'budget')}
							getAriaValueText={valueLabelFormat}
							// aria-labelledby="discrete-slider-always"
							step={1}
							min={2}
							classes={
								{
									valueLabel: 'custom-value-label'
								}
							}
							marks={marks}
							valueLabelDisplay="auto"
						/>
					</div>
				</Grid>
				<Grid item xs={12} style={{ paddingBottom: '16px' }}>
					<FormControlLabel
						control={<Switch id="autoPilot" checked={values.autoPilot} onChange={onChange} />}
						label="Use Vimma budget optimisation"
					/>
					<Tooltip title={AUTOPILOT_HELPTEXT}>
						<IconButton aria-label="helptext">
							<Help />
						</IconButton>
					</Tooltip>
				</Grid>
				<Grid item xs={12} style={{ paddingBottom: '16px' }}>				
					<FormControl component="fieldset">
						<FormLabel className={classes.typography}>Start and end dates</FormLabel>
						<RadioGroup
							aria-label="caption"
							name="caption"
							value={values.goLiveDateType}
							onChange={onChange}
						>
							<FormControlLabel value="today" control={<Radio id="goLiveDateType" />} label="Run continuously starting from today" />
							<FormControlLabel value="date" control={<Radio id="goLiveDateType" />} label="Set start and end dates" />
						</RadioGroup>
					</FormControl>
				</Grid>
				{values.goLiveDateType === 'date' && (
					<React.Fragment>
						<Grid item xs={12} sm={6}>
							<MuiPickersUtilsProvider utils={MomentUtils}>
								<InlineDatePicker
									id="goLiveStartDate"
									margin="normal"
									label="Start date"

									value={values.goLiveStartDate}
									format={'MM/DD/YYYY'}
									onChange={newVal => onChange({ target: { id: 'goLiveStartDate', value: newVal } })}
									error={!!errors.goLiveStartDate}
									helperText={errors.goLiveStartDate ? errors.goLiveStartDate : ''}
									maxDate={moment().add(3, 'months') > values.goLiveEndDate ? moment(values.goLiveEndDate).add(-1, 'days') : moment().add(3, 'months')}
									minDate={moment().add(10, 'days')}
									variant="outlined"
								/>
							</MuiPickersUtilsProvider>
							<Tooltip title={START_DATE_HELPTEXT} style={{ marginTop: '18px' }}>
								<IconButton aria-label="helptext">
									<Help />
								</IconButton>
							</Tooltip>
						</Grid>
						<Grid item xs={12} sm={6}>
							<MuiPickersUtilsProvider utils={MomentUtils}>
								<InlineDatePicker
									id="goLiveEndDate"
									label="End Date"
									margin="normal"

									value={values.goLiveEndDate}
									format={'MM/DD/YYYY'}
									onChange={newVal => onChange({ target: { id: 'goLiveEndDate', value: newVal } })}
									error={!!errors.goLiveEndDate}
									helperText={errors.goLiveEndDate ? errors.goLiveEndDate : ''}
									maxDate={moment().add(6, 'months')}
									minDate={moment().add(1, 'week') > values.goLiveStartDate ? moment().add(1, 'week') : moment(values.goLiveStartDate).add(1, 'days')}
									variant="outlined"
								/>
							</MuiPickersUtilsProvider>
							<Tooltip title={END_DATE_HELPTEXT} style={{ marginTop: '18px' }}>
								<IconButton aria-label="helptext">
									<Help />
								</IconButton>
							</Tooltip>
						</Grid>
					</React.Fragment>
				)}
			</Grid>
		</div >
	);
};

export const Basic = withStyles(CreateCampaignStyles)(BasicScreen);
